/** * * Asynchronously loads the component for
Manage Profile
* */ import { lazyLoad } from "utils/loadable";
export const ManageProfile = lazyLoad(
  () => import("./index"),
  (module) => module.ManageProfile
);
